import { HomePageGuard } from './core/services/authentication/homepageGuard';
import { ManageAccountsGuard } from './shared/guards/manage-accounts.guard';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AuthenticationGuard } from './core/services/authentication/authentication.guard';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MatFormFieldModule } from '@angular/material/form-field';
// Removed incompatible NgxMatNativeDateModule import

import { AuthenticationService } from './core/services/authentication/authentication.service';
import { LatestPolicyGuard } from './shared/guards/latest-policy.guard';
import { SessionManagementService } from './core/services/session/session-management.service';
import { AnnouncementModalService } from 'src/app/core/services/announcement-modal/announcement-modal.service';
import { LabConfigurationGuard } from './shared/guards/lab-configuration.guard';
import { MangePatientGuard } from './shared/guards/manage-patients.guard';
import { ManageProjectsGuard } from './shared/guards/manage-projects.guard';
import { SetPasswordGuard } from './shared/guards/set-password.guard';
import { ManagePackageGuard } from './shared/guards/manage-package.guard';
import { UploadBulkOrderGuard } from './shared/guards/upload-bulk-order.guard';
import { ViewUserActivityLogsGuard } from './shared/guards/view-user-activity-logs.guard';

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        CoreModule,
        SharedModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        OAuthModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
        MatFormFieldModule], providers: [
        AuthenticationGuard,
        SetPasswordGuard,
        LabConfigurationGuard,
        SessionManagementService,
        AuthenticationService,
        LatestPolicyGuard,
        MangePatientGuard,
        ManageProjectsGuard,
        ManageAccountsGuard,
        AnnouncementModalService,
        ManagePackageGuard,
        HomePageGuard,
        UploadBulkOrderGuard,
        ViewUserActivityLogsGuard,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
